import * as React from 'react';

import { createTheme, UnifiThemeProvider } from '@nelnet/unifi-components-react';

const UnifiTheme: React.FunctionComponent = ({ children }) => {
  const unifiTheme = createTheme();
  return <UnifiThemeProvider theme={unifiTheme}>{children}</UnifiThemeProvider>;
};

export default UnifiTheme;
